import React from 'react'
import { Tooltip } from '@mui/material'
import styles from './MenuItem.module.scss'
import SidebarIcon from '../SidebarIcons/SidebarIcon'
import { SidebarMenu } from '../constants/Sidebar'

interface MenuItemProps {
    menuName: SidebarMenu
    goToPage: (menuName: string) => void
    selectedMenu: string
    isIconOnly?: boolean
}

const MenuItem: React.FC<MenuItemProps> = ({
    menuName,
    goToPage,
    selectedMenu,
    isIconOnly = false,
}) => {
    return (
        <Tooltip title={isIconOnly ? menuName : ''} placement="right" arrow>
            <div
                id={styles.menuItem}
                className={`${selectedMenu === menuName ? styles.selected : ''} ${
                    isIconOnly ? styles.iconOnly : ''
                }`}
                onClick={() => goToPage(menuName)}
            >
                <SidebarIcon
                    menuName={menuName}
                    selected={selectedMenu === menuName}
                />
                {!isIconOnly && <span className={styles.menuText}>{menuName}</span>}
            </div>
        </Tooltip>
    )
}

export default MenuItem
